import React from "react";

import { Agent } from "../types/Agent";
import { AgentList } from "./AgentList";
import { SearchInput } from "./SearchInput";
import { LoadingIndicator } from "./LoadingIndicator";
import { AgentPlaceholder } from "./AgentPlaceholder";
import { Country } from "../types/Country";
import { CountryInput } from "./CountryInput";

type AgentWidgetProps = {
  agents: Agent[];
  search: string;
  onSearch: (value: string) => void;
  countries: Country[];
  selectedCountry: string;
  onCountryChange: (value: string) => void;
  isFetching: boolean;
};

export function AgentWidget({
  agents,
  search,
  onSearch,
  countries,
  selectedCountry,
  onCountryChange,
  isFetching,
}: AgentWidgetProps) {
  function handleClearFilters() {
    onSearch("");
    onCountryChange("");
  }

  return (
    <div className="sl-agent-widget flex flex-col h-full mx-auto bg-gray-50 rounded-md border border-gray-200 overflow-clip">
      <div className="flex flex-col h-full">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center sm:gap-3 px-6 lg:px-8 pb-3 sm:pb-0 bg-gray-100 shadow">
          <SearchInput value={search} onChange={onSearch} />
          <CountryInput
            value={selectedCountry}
            countries={countries}
            onChange={onCountryChange}
          />
        </div>
        <div className="overflow-auto h-full">
          {agents.length > 0 ? (
            <AgentList agents={agents} />
          ) : (
            <AgentPlaceholder
              isFiltered={search !== "" || selectedCountry !== ""}
              isFetching={isFetching}
              onClearFilters={handleClearFilters}
            />
          )}
        </div>
      </div>
    </div>
  );
}
